import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bb48042"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { ref, onMounted } from 'vue'

interface Props {
  src: string | undefined
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FadingQRCode',
  props: {
    src: null
  },
  setup(__props: any) {

const props = __props as {
  src: string | undefined
}



const showQrCodeImage = ref(false)

onMounted(() => {
  showQrCodeImage.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("img", {
        src: __props.src,
        width: "100%",
        height: "100%",
        onLoad: _cache[0] || (_cache[0] = ($event: any) => (showQrCodeImage.value = true))
      }, null, 40, _hoisted_1), [
        [_vShow, showQrCodeImage.value]
      ])
    ]),
    _: 1
  }))
}
}

})